import { ChangeDetectorRef, Injectable, NgZone } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { Platform } from '@angular/cdk/platform';
import { finalize, takeUntil } from 'rxjs/operators';
import { Observable, fromEvent } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MediaWatcherHelperService {

    constructor(
        private mediaMatcher: MediaMatcher,
        private ngZone: NgZone,
        private platform: Platform
    ) { }

    buildWatcher(mediaQuery: string, cb: (match: boolean) => void, cdr: ChangeDetectorRef): () => void {

        return () => {
            if (mediaQuery) {
                const match = this.mediaMatcher.matchMedia(`${mediaQuery}`).matches;
                cb(match);
                this.ngZone.run(() => {
                    cdr.markForCheck();
                });
            }
        };
    }

    registerListener(cb: () => void, takeUntilObservable$: Observable<any>) {
        if (this.platform.isBrowser) {
            Promise.resolve().then(() => cb());

            const resizeEvent$ = fromEvent(window, 'resize');
            resizeEvent$
                .pipe(
                    takeUntil(takeUntilObservable$)
                )
                .subscribe(() => {
                    this.ngZone.run(() => {
                        cb();
                    });
                });
        }
    }

}
